export default __webpack_public_path__ + "static/media/b_stayingPositive_large.af83efa9.png";